// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"e7dd6e50","94":"2349c1d9","242":"85c847b8","418":"b81da305","475":"fcc2b11c","537":"8d6d6cb0","680":"6dead89d","702":"1fcfca0a","886":"c6d69a2f"}[chunkId] + ".chunk.css";
};